/**
 * Centralized registry mapping each UI feature to its VpPrivilege read/write names.
 *
 * Single source of truth — every component imports from here instead of using magic strings.
 * The `as const` assertion gives full literal-type autocomplete and compile-time safety.
 */
export const FeaturePrivileges = {
    // --- Enterprise ---
    enterpriseVcSites: { read: 'ENTERPRISE_VC_SITES_READ' },
    enterprisePhonebook: { read: 'ENTERPRISE_PHONEBOOK_READ', write: 'ENTERPRISE_PHONEBOOK_WRITE' },
    enterpriseSettings: { read: 'ENTERPRISE_SETTINGS_READ', write: 'ENTERPRISE_SETTINGS_WRITE' },
    enterpriseTrunkingSites: { read: 'ENTERPRISE_TRUNKING_SITES_READ' },
    enterpriseNumbers: { read: 'ENTERPRISE_NUMBERS_READ' },
    enterpriseAdminMgmt: { read: 'ENTERPRISE_ADMIN_MANAGEMENT_READ', write: 'ENTERPRISE_ADMIN_MANAGEMENT_WRITE' },
    enterpriseRerouting: { read: 'ENTERPRISE_REROUTING_READ', write: 'ENTERPRISE_REROUTING_WRITE' },

    // --- Site ---
    site: { read: 'SITE_SITE_READ', write: 'SITE_SITE_WRITE' },
    users: { read: 'SITE_USERS_READ', write: 'SITE_USERS_WRITE' },
    usersOwn: { write: 'SITE_USERS_OWN_WRITE' },
    devices: { read: 'SITE_DEVICES_READ', write: 'SITE_DEVICES_WRITE' },
    numbers: { read: 'SITE_NUMBERS_READ' },
    callFlows: { read: 'SITE_CALL_FLOWS_READ', write: 'SITE_CALL_FLOWS_WRITE' },
    ivrs: { read: 'SITE_IVRS_READ', write: 'SITE_IVRS_WRITE' },
    schedules: { read: 'SITE_SCHEDULES_READ', write: 'SITE_SCHEDULES_WRITE' },
    announcements: { read: 'SITE_ANNOUNCEMENTS_READ', write: 'SITE_ANNOUNCEMENTS_WRITE' },
    phonebook: { read: 'SITE_PHONEBOOK_READ', write: 'SITE_PHONEBOOK_WRITE' },
    callCenters: { read: 'SITE_CALL_CENTERS_READ', write: 'SITE_CALL_CENTERS_WRITE' },
    callPickupGroups: { read: 'SITE_CALL_PICKUP_GROUPS_READ', write: 'SITE_CALL_PICKUP_GROUPS_WRITE' },
    executiveAssistants: { read: 'SITE_EXECUTIVE_ASSISTANTS_READ', write: 'SITE_EXECUTIVE_ASSISTANTS_WRITE' },
    paging: { read: 'SITE_PAGING_READ', write: 'SITE_PAGING_WRITE' },
    featureAccessCodes: { read: 'SITE_FEATURE_ACCESS_CODES_READ' },
    emergencyDivert: { read: 'SITE_EMERGENCY_DIVERT_READ', write: 'SITE_EMERGENCY_DIVERT_WRITE' },
    emergencyCalls: { read: 'SITE_EMERGENCY_CALLS_READ', write: 'SITE_EMERGENCY_CALLS_WRITE' },
    blacklistedNumbers: { read: 'SITE_BLACKLISTED_NUMBERS_READ', write: 'SITE_BLACKLISTED_NUMBERS_WRITE' },
    businessReporting: { read: 'SITE_BUSINESS_REPORTING_READ', write: 'SITE_BUSINESS_REPORTING_WRITE' },

    // --- Trunk ---
    trunkSite: { read: 'TRUNK_SITE_READ', write: 'TRUNK_SITE_WRITE' },
} as const


